import React, {
    useContext, useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { useLocation } from 'react-router-dom';
import { Link } from '@jutro/components';
import './SgCepSideMenu.messages';

const desktopMenuOptions = [
    {
        id: 'home',
        exact: true,
        path: '/home',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.PolicySummary'
        }
    },
    {
        id: 'changePolicy',
        exact: true,
        path: '/endorsement',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.AmendPolicy'
        }
    },
    {
        id: 'payments',
        exact: true,
        path: '/billing-summary',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.Payments'
        }
    },
    {
        id: 'documents',
        exact: true,
        path: '/documents',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.Documents'
        }
    },
    {
        id: 'makeClaim',
        exact: true,
        path: '/claim',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.Claims'
        }
    },
    {
        id: 'account',
        exact: true,
        path: '/ampuserprofile',
        showOnNavBar: true,
        title: {
            id: 'cep.components.sgCepSideMenu.navigation.Account'
        }
    }
];

function SgCepSideMenu() {
    const location = useLocation();
    const translator = useContext(TranslatorContext);
    const drawDesktopOptions = useMemo(() => {
        const isActive = (option) => {
            return location.pathname.includes(option.path);
        };
        return desktopMenuOptions.map((option) => {
            return (
                <div className="sgMenuTab" key={option.id}>
                    <Link to={option.path} id={`menuLink${option.id}`} className={`sgMenuLink ${isActive(option) && 'active'}`}>
                        {translator(option.title)}
                    </Link>
                </div>
            );
        });
    }, [location, translator]);

    return (
        <div className="menu" role="menubar" aria-label="Main menu">
            {drawDesktopOptions}
        </div>
    );
}

export default SgCepSideMenu;
